<template>
    <div
        class="WeirdCounter"
    >
        <div class="content1 font-size-middle">{{ price }}</div>
        <div class="content2 font-size-small">{{ period }}</div>
        <div class="content3 font-size-small">{{ quantity }}</div>
    </div>
</template>

<script>
export default {
    name: 'WeirdCounter',
    props: {
        price: {
            type: String,
            default: '19zł',
        },
        period: {
            type: String,
            default: '30dni',
        },
        quantity: {
            type: String,
            default: '1osoba',
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '@/assets/scss/_variables.scss';
    @import "@/assets/scss/bulma/projectBulma.scss";

    .WeirdCounter {
        display: flex;
        align-items: center;
        user-select: none;
        font-family: "Roboto", sans-serif;
        padding: 5px;
        color: white;
        font-weight: normal;

        .content1 {
            padding-right: 5px;
            font-weight: bold;
        }

        .content2, .content3 {
            padding: 0 5px;
            border-left: 1px solid white;
        }
    }
</style>
